import { createAsyncThunk } from '@reduxjs/toolkit';
import qs from 'query-string';
import { FeedbackRequestRO, Pagination } from 'store/interfaces';
import api from 'api';
import {
  API_FEEDBACK_REQUEST_OWN,
  API_FEEDBACK_REQUEST_OWN_HISTORY,
} from 'constants/api';
import { storeName } from '../config';

export const getFeedbackRequestById = createAsyncThunk<
  FeedbackRequestRO | null,
  { id: number; isHistory?: boolean }
>(`${storeName}/getById`, async ({ id, isHistory }, thunkAPI) =>
  api.axios
    .get<{ list: FeedbackRequestRO[]; pagination: Pagination }>(
      `${
        isHistory ? API_FEEDBACK_REQUEST_OWN_HISTORY : API_FEEDBACK_REQUEST_OWN
      }?${qs.stringify({ id }, { skipNull: true })}`,
    )
    .then((res) => res.data.list[0] ?? null)
    .catch((e) => thunkAPI.rejectWithValue(e.response?.data)),
);
